import request from '../utils/request'

/**
 * 直播相关接口
 */

// 获取直播信息
export function getLiveInfo() {
  return request({
    url: '/h5/live/info',
    method: 'get'
  })
}

// 轻量查询直播状态（轮询用，不增加观看人数）
export function getLiveStatus() {
  return request({
    url: '/h5/live/status',
    method: 'get'
  })
}

// 获取直播商品列表
export function getLiveGoods() {
  return request({
    url: '/h5/live/goods',
    method: 'get'
  })
}

// 增量同步直播商品（传入本地版本号，有新版本才返回商品数据）
export function syncLiveGoods(version) {
  return request({
    url: '/h5/live/goods/sync',
    method: 'get',
    params: { version }
  })
}

// 获取弹幕列表
export function getDanmu(params) {
  return request({
    url: '/h5/live/danmu',
    method: 'get',
    params
  })
}

// 发送弹幕/留言
export function sendDanmu(data) {
  return request({
    url: '/h5/live/danmu',
    method: 'post',
    data
  })
}

// 点赞
export function likeLive(data) {
  return request({
    url: '/h5/live/like',
    method: 'post',
    data
  })
}

// 关注主播
export function followAnchor(data) {
  return request({
    url: '/h5/live/follow',
    method: 'post',
    data
  })
}

// 获取在线人数
export function getOnlineCount() {
  return request({
    url: '/h5/live/online',
    method: 'get'
  })
}

// 发送礼物
export function sendGift(data) {
  return request({
    url: '/h5/live/gift',
    method: 'post',
    data
  })
}

// 获取本场直播礼物统计
export function getGiftStats() {
  return request({
    url: '/h5/live/gift/stats',
    method: 'get'
  })
}

// 获取第一个启用的主播（分享页背景形象照用）
export function getFirstAnchor() {
  return request({
    url: '/h5/live/anchor/first',
    method: 'get'
  })
}

// 观看直播-进入直播间
export function watchEnter(data) {
  return request({
    url: '/h5/live/watch/enter',
    method: 'post',
    data
  })
}

// 观看直播-心跳上报（每30秒）
export function watchHeartbeat(data) {
  return request({
    url: '/h5/live/watch/heartbeat',
    method: 'post',
    data
  })
}

// 观看直播-离开直播间
export function watchLeave(data) {
  return request({
    url: '/h5/live/watch/leave',
    method: 'post',
    data
  })
}

// 观看直播-查询观看进度和奖励状态
export function getWatchStatus(sessionId) {
  return request({
    url: '/h5/live/watch/status',
    method: 'get',
    params: { sessionId }
  })
}
